module.exports = "/_next/static/images/game-1-phone-gallery-08-27-0830-e8a2da6ce46fa4a57ad3283f26c4f72a.jpg";